import { useEffect, useRef, useState } from "react";
import Toggle from "@helsenorge/designsystem-react/components/Toggle";
import HelpBubble from "@helsenorge/designsystem-react/components/HelpBubble";
import HelpTriggerIcon from "@helsenorge/designsystem-react/components/HelpTriggerIcon";
import { useGetResources } from "../../hooks/useGetResources";
import { useAppDispatch, useAppSelector } from "../../store/reducer";
import { skjulOppgaveForFullmakt } from "../../store/thunks/thunk-oppgaveDetaljer";
import { SkjulSamtaleStatus } from "../../enums/skjulSamtaleStatus";
import { setSkjulSamtaleStatus } from "../../store/slices/slice-oppgaveDetaljer";

import styles from "../../styles/oppgave-detaljer.module.scss";
import Modal from "@helsenorge/designsystem-react/components/Modal";
import { FULLMAKT_PATH } from "HNEntities/url-types";
import { getModalDescription } from "utils/details-utils";

export const FullmaktToggle = (): React.JSX.Element | null => {
  const controllerRef = useRef<HTMLButtonElement>(null);
  const resources = useGetResources();
  const dispatch = useAppDispatch();
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);
  const skjulSamtaleStatus = useAppSelector(
    (state) => state.oppgaveDetaljer.skjulSamtaleStatus,
  );

  const [showBubble, setShowBubble] = useState(false);
  const [toggleChecked, setToggleChecked] = useState(
    oppgave?.SkjulForFullmakt ?? false,
  );

  useEffect(() => {
    setToggleChecked(oppgave?.SkjulForFullmakt ?? false);
  }, [oppgave?.SkjulForFullmakt]);

  const showModal =
    skjulSamtaleStatus === SkjulSamtaleStatus.Success ||
    skjulSamtaleStatus === SkjulSamtaleStatus.Failed;

  const handleSkjulForFullmakt = async () => {
    if (oppgave?.Id) {
      await dispatch(
        skjulOppgaveForFullmakt({
          oppgaveGuid: oppgave?.Id,
          skjulForFullmakt: !toggleChecked,
        }),
      );
    }
    setToggleChecked(!toggleChecked);
  };

  return (
    <div className={styles.toggle}>
      <Toggle
        checked={toggleChecked}
        label={[
          {
            text: resources?.knapp_skjul_oppgave || "",
            type: "subdued",
          },
        ]}
        onChange={handleSkjulForFullmakt}
      />
      <HelpTriggerIcon
        className={styles.helpTriggerIcon}
        ref={controllerRef}
        onClick={() => setShowBubble(true)}
        ariaLabel={resources?.ariaLabel_helpTrigger || ""}
      />
      <HelpBubble
        showBubble={showBubble}
        onClose={() => setShowBubble(false)}
        controllerRef={
          controllerRef as React.RefObject<HTMLElement | SVGSVGElement>
        }
        linkText={resources?.fullmakt_helpbubble_lenke || ""}
        linkUrl={FULLMAKT_PATH}
      >
        {resources?.fullmakt_helpbubble || ""}
      </HelpBubble>
      {showModal && (
        <Modal
          variant="success"
          title={resources?.modal_fullmakt_title || ""}
          description={getModalDescription(
            skjulSamtaleStatus,
            oppgave,
            resources,
          )}
          primaryButtonText={
            resources?.redirect_modal_continue_button_text || ""
          }
          onSuccess={() => {
            dispatch(setSkjulSamtaleStatus(null));
          }}
          onClose={() => {
            dispatch(setSkjulSamtaleStatus(null));
          }}
        />
      )}
    </div>
  );
};
